module.exports = __webpack_public_path__ + "img/17a002-15.4ebb2ffd.jpg";